const Styles = () => ({
  card: {
    background: "transparent"
  },
  media: {
    height: 740,
  },
  titleText: {
    color: "white",
    fontSize: "24px",
  },
  subtitleText: {
    color: "white",
    fontSize: "24px",
  },
  mediaRoot: {
    minHeight: "400px"
  },
  focusHighlight: {
    borderRadius: "none",
  }
});

export default Styles;
